import ScenarioService from "@/services/scenario.service";
import lodash from "lodash";

const { NodeType } = ScenarioService

function createTreeLayout ({ startId, nodeList, layoutConfig, onlyShowNodes }) {
    let NodeOutMap = {};
    let root = null;
    let nodeOutList = [];
    let nodeFlowList = [];
    let linkOutList = [];
    for (let node of nodeList) {
        let nodeOut = {
            id: node.id,
            data: node,
            children: [],
            parentList: [],
            depth: 0,
            isAligned: false,
            visible: true,
            x: -1,
            y: -1
        }
        NodeOutMap[node.id] = nodeOut

        if (node.id === startId) {
            root = nodeOut
        }
    }

    if (!root) {
        return
    }

    // update visible
    if (layoutConfig.focusId) {
        for (let node of nodeList) {
            NodeOutMap[node.id].visible = false
        }
        let nodeOutFocus = NodeOutMap[layoutConfig.focusId]
        nodeOutFocus.visible = true
        for (let childId_1 of nodeOutFocus.data.children) {
            let childOut_1 = NodeOutMap[childId_1]
            nodeOutList.push(childOut_1)
            childOut_1.visible = true
            nodeOutFocus.children.push(childOut_1)
            childOut_1.parentList.push(nodeOutFocus)
            linkOutList.push({ source: nodeOutFocus, target: childOut_1 })
            for (let childId_2 of childOut_1.data.children) {
                let childOut_2 = NodeOutMap[childId_2]
                childOut_2.visible = true
                nodeOutList.push(childOut_2)
                childOut_1.children.push(childOut_2)
                childOut_2.parentList.push(childOut_1)
                linkOutList.push({ source: childOut_1, target: childOut_2 })
            }
        }
        root = nodeOutFocus
        nodeOutList.push(nodeOutFocus)
    } else {
        let showNodes = onlyShowNodes ? onlyShowNodes : nodeList
        for (let node of showNodes) {
            let nodeOut = NodeOutMap[node.id]
            nodeOutList.push(nodeOut)
            let nodeChildren = node.children.filter(childId => showNodes.find(node => node.id === childId))
            for (let childId of nodeChildren) {
                let childOut = NodeOutMap[childId]
                nodeOut.children.push(childOut)
                childOut.parentList.push(nodeOut)
                if (!layoutConfig.usePortal && childOut.data.type === NodeType.PORTAL) {
                    linkOutList.push({ source: nodeOut, target: NodeOutMap[childOut.data.config.id] })
                } else {
                    linkOutList.push({ source: nodeOut, target: childOut })
                }
            }
        }
    }

    for (let nodeOut of nodeOutList) {
        nodeOut.children = lodash.orderBy(nodeOut.children, item => item.data.is_fallback ? 1 : 0)
    }

    // breath first iterate
    let map = {}
    function loopTree (node, deep, minY) {
        if (map[node.id]) {
            return minY
        }
        map[node.id] = true
        node.x = deep
        node.y = minY
        let maxChildrenY = minY
        for (let i = 0; i < node.children.length; i++) {
            let newChildrenY = loopTree(
                node.children[i],
                deep + 1,
                i === 0 ? maxChildrenY : maxChildrenY + 1
            )
            if (maxChildrenY < newChildrenY) {
                maxChildrenY = newChildrenY
            }
        }
        return maxChildrenY
    }

    let minY = loopTree(root, 0, 0)
    for (let nodeOut of nodeOutList) {
        if (nodeOut.parentList.length < 1 && nodeOut !== root) {
            minY = loopTree(nodeOut, 0, minY + 1)
        }
    }

    // get children node
    function getChildrenNode (nodeRoot) {
        let childrenNode = []
        if (nodeRoot.children.length === 0) {
            return childrenNode
        } else {
            childrenNode.push(...nodeRoot.children)
            nodeRoot.children.forEach(item => {
                childrenNode.unshift(...getChildrenNode(item))
            })
        }
        return childrenNode
    }

    for (let nodeItem of nodeOutList) {
        nodeFlowList.push({
            id: nodeItem.id,
            children: getChildrenNode(nodeItem)
        })
    }

    return { nodeFlowList, nodeOutList, linkOutList, NodeOutMap };
}

export default createTreeLayout;
